import {Component, inject} from '@angular/core';
import { AuthenticationService } from '@services/authentication.service';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    standalone: false
})
export class AppHeaderComponent {
    public authenticationService = inject(AuthenticationService);
}
